export default __webpack_public_path__ + "static/media/emailRed.423796dd.svg";